// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetPublicHolidaysRequestModel from '../../model/get-public-holidays-request-model';
import GetPublicHolidaysRequestDTO from '../dto/get-public-holidays-request-dto';
import dtoSchema from '../schemas/get-public-holidays-request-schema';

export default abstract class GetPublicHolidaysRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetPublicHolidaysRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.dateFrom = data.dateFrom;
      this.dateTo = data.dateTo;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {date-time}
  */
  dateFrom?: string;
  /**
  * @type {date-time}
  */
  dateTo?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetPublicHolidaysRequestDTO>): GetPublicHolidaysRequestModel;
  static toModel(dto: DeepPartial<GetPublicHolidaysRequestDTO> | undefined | null): GetPublicHolidaysRequestModel | undefined;
  static toModel(dto: DeepPartial<GetPublicHolidaysRequestDTO> | undefined | null): GetPublicHolidaysRequestModel | undefined {
    return dto ? new GetPublicHolidaysRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetPublicHolidaysRequestModel> | GetPublicHolidaysRequestModel): GetPublicHolidaysRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      dateFrom: unwrapped.dateFrom,
      dateTo: unwrapped.dateTo,
      searchCriteria: unwrapped.searchCriteria,
    } as GetPublicHolidaysRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetPublicHolidaysRequestModel, can not map to GetPublicHolidaysRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
